import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../service/auth.service';

@Component({
    selector: 'app-userbar',
    templateUrl: './userbar.component.html'
})
export class UserbarComponent implements OnInit {

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    logout() {
        return this.auth.destroy();
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/layout/userbar/userbar.component.ts